// extracted by mini-css-extract-plugin
export default {"vigyaancontainer":"Vigyaan_vigyaancontainer__UAmIL","vigyaanphone":"Vigyaan_vigyaanphone__6+AM0","vigyaanlappy":"Vigyaan_vigyaanlappy__canGy"};